<template>
  <div class="c-main">
    <div class="c-tabs">
      <div class="c-tabs__tab-bar">
        <router-link
          v-for="rotation in session.rotationsSet"  :key="rotation.index"
          class="c-button c-button--large c-button--ghost c-tabs__tab-link" exact
          :to="{ name: 'cis.session.panels', params: { rotation: rotation.index }}"
        >
          <span class="c-tabs__tab-link-title">{{ $t('rotation') }} {{ rotation.index + 1 }}</span>
          <span class="c-tabs__tab-link-subtitle">{{ $t('session.status.' + rotation.status) }}</span>
        </router-link>
      </div>

      <div class="c-tabs__panel u-margin-top-medium" id="panel">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import find from "lodash/find";

  export default {
    name: "cis-session",
    computed: {
      session: function() {
        return find(this.$store.state.sessions.items, (item) => item.id === this.$route.params.sessionId)
      },
    }
  }
</script>
